import { connect } from 'react-redux';
import AddCustomer from "../Component/AddCustomer";
import {
  checkZipCode,
  getLeadById,
  pricingCalculator,
  addServiceOrderEnquiry,
  resetCheckZipcode,
  resetPricingCalculator,
  addNonServiceableEnquiry,
  addCustomer,
  getFieldTechnicianFilter,
  validateCoupon,
  getGeocodeAddress,
  resetGeocodeAddress,
  addNewCard,
  addServiceOrder,
  getFieldOfficeById,
  updateCustomer,
  checkEmail,
} from '../../../../Action'

const mapStateToProps = (state) => {
  
  const {
    ZipcodeCheck,
    PricingCalc,
    ServiceOrderEnquiry,
    CustomerList,
    GoogleApi,
    ServiceOrder,
    FieldTechnicianFilter,
    ValidateCouponCode,
    EmailVerifycation,
  } = state;

  return {
    ZipcodeCheck,
    PricingCalc,
    ServiceOrderEnquiry,
    CustomerList, 
    GoogleApi, 
    ServiceOrder,
    FieldTechnicianFilter,
    ValidateCouponCode,
    EmailVerifycation
  }
}

const actionCreators = {
  resetPricingCalculator,
  resetCheckZipcode,
  checkZipCode,
  getLeadById,
  pricingCalculator,
  addServiceOrderEnquiry,
  addNonServiceableEnquiry,
  addCustomer,
  getGeocodeAddress,
  resetGeocodeAddress,
  addNewCard,
  addServiceOrder,
  getFieldOfficeById,
  getFieldTechnicianFilter,
  validateCoupon,
  updateCustomer,
  checkEmail,
}
export default (connect(mapStateToProps, actionCreators)(AddCustomer));